import React from "react";

export interface StudioFeatureModalProps {
  isOpen: boolean;
  onClose: () => void;
  featureTitle?: string;
}

export function StudioFeatureModal({
  isOpen,
  onClose,
  featureTitle = "Voice Cloning & Virtual Audio",
}: StudioFeatureModalProps) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0, 0, 0, 0.75)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        padding: "20px",
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "460px",
          background: "#111418",
          border: "1px solid rgba(255, 255, 255, 0.12)",
          borderRadius: "16px",
          padding: "28px",
          boxShadow: "0 24px 48px rgba(0, 0, 0, 0.7), 0 0 1px 1px rgba(255, 255, 255, 0.05)",
          color: "#f3f4f6",
          fontFamily: "var(--font-sans, system-ui, -apple-system, sans-serif)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              style={{
                fontSize: "11px",
                fontWeight: 700,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                background: "rgba(56, 189, 248, 0.15)",
                color: "#38bdf8",
                padding: "3px 8px",
                borderRadius: "6px",
                border: "1px solid rgba(56, 189, 248, 0.3)",
              }}
            >
              Studio Workstation
            </span>
            <span
              style={{
                fontSize: "11px",
                fontWeight: 600,
                background: "rgba(245, 158, 11, 0.15)",
                color: "#fbbf24",
                padding: "3px 8px",
                borderRadius: "6px",
                border: "1px solid rgba(245, 158, 11, 0.3)",
              }}
            >
              Private Beta
            </span>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              color: "#9ca3af",
              fontSize: "20px",
              cursor: "pointer",
              lineHeight: 1,
              padding: "4px",
            }}
          >
            ✕
          </button>
        </div>

        <h3 style={{ fontSize: "18px", fontWeight: 700, color: "#ffffff", marginBottom: "12px", letterSpacing: "-0.01em" }}>
          {featureTitle}
        </h3>

        <div style={{ fontSize: "14px", color: "#94a3b8", lineHeight: 1.6, marginBottom: "20px" }}>
          <p style={{ margin: "0 0 12px 0" }}>
            Real-time vocal cloning, neural speech conversion, and low-latency virtual audio routing (VB-Cable / OBS Audio) are dedicated capabilities of <strong>StreamPersona Studio Workstation</strong>.
          </p>
          <p style={{ margin: "0 0 12px 0" }}>
            <strong>StreamPersona Lite</strong> is engineered exclusively for zero-inbound cloud neural visual synthesis over NVIDIA RTX 5090 Blackwell clusters.
          </p>
          <p style={{ margin: 0, fontSize: "12px", color: "#64748b" }}>
            Studio Workstation preview builds are currently rolling out to early enterprise and studio partners.
          </p>
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={onClose}
            style={{
              background: "linear-gradient(135deg, #00d4aa 0%, #00b4d8 100%)",
              color: "#0a0d10",
              fontWeight: 700,
              fontSize: "13px",
              padding: "9px 22px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              transition: "transform 0.15s ease, filter 0.15s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.filter = "brightness(1.1)")}
            onMouseLeave={(e) => (e.currentTarget.style.filter = "none")}
          >
            Understood
          </button>
        </div>
      </div>
    </div>
  );
}
